<script>
import Layout from "../../layouts/main.vue";
import PageHeader from "@/components/page-header";
import appConfig from "../../../app.config";
import axios from 'axios';
import DataTable from 'datatables.net-vue3';
import moment from 'moment';

export default {
    page: {
        title: "Add New User",
        meta: [
            {
                name: "description",
                content: appConfig.description,
            },
        ],
    },
    data() {
        return {
            title: "Add New User",
            programList:[],
            programListData:[],
            channelpartnerlist: [],
            countryList: [],
            branchList: [],
            rawBranchList: [],
            fullname: '',
            program_id: '',
            channel_partner_id: '',
            branch_id: '',
            email: '',
            password:'',
            confirm_password:'',
            loadingProgram:true,
            loadingUpload:true,
            loadingCp:true,
            loadingBranch:true,
            staticURLDownload:process.env.VUE_APP_LANDING,
        };
    },

    methods: {
        format_date(value){
            if (value) {
                return moment(String(value)).format('YYYY-MM-DD HH:mm:ss')
            }
        }, 
        
        downloadtemplate: function () {
            location.href= process.env.VUE_APP_LANDING+'/storage/external_users_template.xlsx';
        },

        createExternalUser(e)
        { 
            if(this.confirm_password == this.password){
                e.preventDefault()

                const posting_ = {                   
                    name: this.fullname,
                    email: this.email,
                    password: this.password,
                    program_id: this.program_id,
                    channel_partner_id: this.channel_partner_id,
                    branch_id: this.branch_id,
                };

                axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
                axios.post(process.env.VUE_APP_API_BASEURL+'externalUser/createExternalUser', posting_)
                .then(response => {
                    if (response) {
                        document.getElementById("createNewUser").reset();
                        alert(response.data.msj);
                        this.$router.push({ name: 'ExternalUser' });
                    }
                    else{
                        console.log('tak ok');
                    }
                });
            }else{
                e.preventDefault()
                alert('Password Not Match!')
            }
        },

        submitFile(){
            let formData = new FormData();
            formData.append('sourceFile', this.sourceFile);
            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.post(process.env.VUE_APP_API_BASEURL+'externalUser/bulkUploadUsers',
                formData,
                {
                    headers: {
                        'Content-Type':'multipart/form-data'
                    }
                }
            ).then(response => {
                if (response) {
                    this.loadingUpload=false;
                    console.log(response);
                    alert(response.data.message);
                    this.$router.push({ name: 'ExternalUser' });
                } 
                else {
                    this.messageBag = ['No record.'];
                }
            })
            .catch(error => {
                this.messageBag = [error.error];
            });
        },

        handleFileUpload(){
            this.sourceFile = this.$refs.sourceFile.files[0];
        },

        selectChannelPartner(){
            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.get(process.env.VUE_APP_API_BASEURL+'externalUser/getBranchListByChannelPartner/'+this.channel_partner_id)
            .then(response => {
                if (response) {
                    this.branchList = response.data;
                    console.log(this.branchList);
                } 
                else {
                    alert('No branch data found');
                }
            })
            .catch(error => {
                this.messageBag = [error.error];
            });

            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.get(process.env.VUE_APP_API_BASEURL+'externalUser/getProgramByChannelPartner/'+this.channel_partner_id)
            .then(response => {
                if (response) {
                    this.programListData = response.data;
                    console.log(this.programListData);
                } 
                else {
                    alert('No branch data found');
                }
            })
            .catch(error => {
                this.messageBag = [error.error];
            });
        },
        

        //raw data----------------------------------------------------------
        get_channel_partner(){
            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.get(process.env.VUE_APP_API_BASEURL+'channelpartner/raw_data')
            .then(response => {
                if (response) {
                    this.loadingCp=false;
                    this.channelpartnerlist = response.data;
                    console.log(this.channelpartnerlist);
                } 
                else {
                    this.messageBag = ['No record.'];
                }
            })
            .catch(error => {
                this.messageBag = [error.error];
            });
        },

        get_program(){
            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.get(process.env.VUE_APP_API_BASEURL+'program/raw_data')
            .then(response => {
                if (response) {
                    this.loadingProgram=false;
                    this.programList = response.data;
                    console.log(this.programList);
                } 
                else {
                    this.messageBag = ['No record.'];
                }
            })
            .catch(error => {
                this.messageBag = [error.error];
            });
        },

        getBranchList(){
            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.get(process.env.VUE_APP_API_BASEURL+'branch/list')
            .then(response => {
                if (response) {
                    this.loadingBranch=false;
                    this.rawBranchList = response.data;
                    console.log(this.rawBranchList);
                } 
                else {
                    this.messageBag = ['No record.'];
                }
            })
            .catch(error => {
                this.messageBag = [error.error];
            });
        },

        //raw data----------------------------------------------------------
    },

    components: {
        Layout,
        PageHeader,
        DataTable, 
    },

    mounted() {       
        this.get_channel_partner();
        this.get_program();               
        this.getBranchList();               
    },
};
require("@/assets/css/datatable.css");
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-xl-6">
        <div class="card">
          <div class="card-header">
            <div class="d-flex align-items-center">
              <h4><span class="badge badge-soft-primary badge-border"><i class="ri-information-line align-middle me-1"></i>External User's Information</span></h4>
            </div>
          </div>
          <div class="card-body">
            <div class="live-preview">
              <form @submit="createExternalUser" id="createNewUser">
                <div class="row mb-3">
                  <div class="col-lg-3">
                    <label for="branch_name" class="form-label">Name<span class="text-danger">*</span></label>
                  </div>
                  <div class="col-lg-9">
                    <input type="text" v-model='fullname' class="form-control" id="firstName" placeholder="Enter Full Name" required/>
                  </div>
                </div>
                <div class="row mb-3">
                  <div class="col-lg-3">
                    <label for="branch_code" class="form-label">Email Address<span class="text-danger">*</span></label>
                  </div>
                  <div class="col-lg-9">
                    <input type="email" class="form-control" id="emailInput" v-model='email' placeholder="Enter email" required/>
                  </div>
                </div>
                <div class="row mb-3">
                  <div class="col-lg-3">
                    <label for="channel_partner_id" class="form-label">Channel Partner<span class="text-danger">*</span></label>
                  </div>
                  <div class="col-lg-9">
                    <select v-model="channel_partner_id" class="form-select mb-3" v-on:change="selectChannelPartner" arial-label="Default select example" required>
                        <option value="">--- Select Channel Partner ---</option>
                        <option v-for="(item, index) in channelpartnerlist" :key="index" :value="item.id" >
                            {{ item.name }}
                        </option>
                    </select>
                  </div>
                </div>
                <div class="row mb-3">
                  <div class="col-lg-3">
                    <label for="channel_partner_id" class="form-label">Branch<span class="text-danger">*</span></label>
                  </div>
                  <div class="col-lg-9">
                    <select v-model="branch_id" class="form-select mb-3" arial-label="Default select example" required>
                        <option value="">--- Select Branch ---</option>
                        <option v-for="(item, index) in branchList" :key="index" :value="item.id" >
                            {{ item.name }}
                        </option>
                    </select>
                  </div>
                </div>
                <div class="row mb-3">
                  <div class="col-lg-3">
                    <label for="channel_partner_id" class="form-label">Program<span class="text-danger">*</span></label>
                  </div>
                  <div class="col-lg-9">
                    <select v-model="program_id" class="form-select mb-3" arial-label="Default select example" placeholder="Please Select" required>
                        <option value="">--- Select Program ---</option>
                        <option v-for="(item, index) in programListData" :key="index" :value="item.id" >
                            {{ item.program_name }}
                        </option>
                    </select>
                  </div>
                </div>
                <div class="row mb-3">
                  <div class="col-lg-3">
                    <label for="email" class="form-label">Password<span class="text-danger">*</span></label>
                  </div>
                  <div class="col-lg-9">
                    <input type="password" class="form-control" v-model='password' placeholder='**********' id="passwordInput" required/>
                  </div>
                </div>
                <div class="row mb-3">
                  <div class="col-lg-3">
                    <label for="email2" class="form-label">Confirm Password<span class="text-danger">*</span></label>
                  </div>
                  <div class="col-lg-9">
                    <input type="password" class="form-control" v-model='confirm_password' placeholder='**********' id="passwordInput" required/>
                  </div>
                </div>
                
                <hr class="my-4 text-muted">
                <div class="text-end col-lg-12">
                  <a @click="$router.go(-1)" class="btn btn-success">Back</a>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  <button type="submit" class="btn btn-primary">
                    Create
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>        
      </div>

      <div class="col-xl-6">    
        <div class="card">
          <div class="card-header">
            <div class="d-flex">
              <h4><span class="badge badge-soft-primary badge-border"><i class="ri-map-pin-line align-middle me-1"></i>Bulk Upload</span></h4>
            </div>
          </div>
          <div class="card-body">
            <div>
                <div class="card-body border-bottom-dashed border-bottom">           
                    <div class="row g-12">
                        <div class="col-xl-8">                  
                            <input class="form-control" type="file" ref="sourceFile" v-on:change="handleFileUpload()">
                        </div>
                        <div class="col-xl-4">
                        <div class="row g-12">
                            <div class="col-sm-12">
                            <button v-on:click="submitFile()" class="btn btn-success w-100">
                                <i class="ri-equalizer-fill me-2 align-bottom"></i>Upload
                                </button>
                            </div>
                        </div>
                        </div>
                        <div>
                            <a :href="staticURLDownload+'/storage/external_users_template.xlsx'">Download Template</a>
                        </div>
                    </div>
                    <hr class="my-4 text-muted">
                    <label for="firstName" class="form-label">Program List</label>
                    <div v-if='loadingProgram'>
                        <div class="spinner-border text-success" role="status">
                            <span class="sr-only">Loading...</span>
                        </div>
                    </div>
                    <div v-else>
                        <div class="table-responsive">
                            <DataTable :options="{lengthChange: false,searching: false, paging: false, info: false}" class="table table-striped table-nowrap mb-0" id="example"> 
                                <thead class="table-secondary">
                                    <tr>                                   
                                        <th scope="col" width="80%">Program Name</th>
                                        <th scope="col">ID</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    
                                    <tr v-for="(item, index) in programList" :key="index" class="content">                                   
                                        <td>{{ item.program_name }}</td>  
                                        <td>{{ item.id }}</td>                                 
                                    </tr>
                                </tbody>
                            </DataTable>
                        </div>
                    </div>
                    <hr class="my-4 text-muted">
                    <label for="firstName" class="form-label">Channel Partner List</label>
                    <div v-if='loadingCp'>
                        <div class="spinner-border text-success" role="status">
                            <span class="sr-only">Loading...</span>
                        </div>
                    </div>
                    <div v-else>
                        <div class="table-responsive">
                            <DataTable :options="{lengthChange: false,searching: false, paging: false, info: false}" class="table table-striped table-nowrap mb-0" id="example"> 
                                <thead class="table-secondary">
                                    <tr>                                   
                                        <th scope="col" width="80%">Channel Partner Name</th>
                                        <th scope="col">ID</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    <tr v-for="(item, index) in channelpartnerlist" :key="index" class="content">
                                        <td>{{ item.name }}</td>                                   
                                        <td>{{ item.id }}</td>                                   
                                    </tr>
                                </tbody>
                            </DataTable>
                        </div>
                    </div>
                    <hr class="my-4 text-muted">
                    <label for="firstName" class="form-label">Branch List</label>
                    <div v-if='loadingBranch'>
                        <div class="spinner-border text-success" role="status">
                            <span class="sr-only">Loading...</span>
                        </div>
                    </div>
                    <div v-else>
                        <div class="table-responsive">
                            <DataTable :options="{lengthChange: false, info: false}" class="table table-striped table-nowrap mb-0" id="example"> 
                                <thead class="table-secondary">
                                    <tr>                                   
                                        <th scope="col" width="80%">Branch Name</th>
                                        <th scope="col">ID</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    <tr v-for="(item, index) in rawBranchList" :key="index" class="content">
                                        <td>{{ item.name }}</td>                                   
                                        <td>{{ item.id }}</td>                                   
                                    </tr>
                                </tbody>
                            </DataTable>
                        </div>
                    </div>
                </div>                  
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
